<template>
  <div class="row mx-0">
    <div class="col-1"></div>
    <div class="col-10">
      <div class="p-0 m-0 mt-4 main-title">排程試算</div>
      <div style="margin-top: 2rem">
        <commonQueryInput
          :inputItems="multiInputItems"
          v-model:getValue="multiInputVal"
        ></commonQueryInput>
      </div>
      <div
        v-if="query"
        class="d-flex justify-content-end align-items-end"
        style="margin-bottom: 0.6rem"
      >
        <template v-if="!mod">
          <button
            v-if="meltSchedule.length == 0"
            type="button"
            class="btn me-3"
            style="
              color: var(--main-font-color);
              background-color: var(--main-bg-color);
              min-width: 5rem;
              height: 1.375rem;
              padding: 0px 0.5rem;
              font-family: dfyuanstd-w7;
              font-size: 0.875rem;
              font-weight: normal;
            "
            @click="meltSchedulePlanningModalShow = true"
          >
            進行排程
          </button>
          <button
            v-if="meltSchedule.length != 0"
            type="button"
            class="btn me-3"
            style="
              color: var(--main-font-color);
              background-color: var(--main-bg-color);
              min-width: 5rem;
              height: 1.375rem;
              padding: 0px 0.5rem;
              font-family: dfyuanstd-w7;
              font-size: 0.875rem;
              font-weight: normal;
            "
            @click="editMeltSchedule"
          >
            編輯模式
          </button>
          <exportCsv
            v-if="meltSchedule.length != 0"
            :exportData="exportData"
            :exportFileName="exportFileName()"
            :type="'xlsx'"
            :autoCol="true"
            :buttonName="'匯出週排程表'"
          />
        </template>
        <template v-else>
          <button
            type="button"
            class="btn me-3 edit-btn"
            :class="{ active: transferStatus == 1 }"
            @click="transferStatus = 1"
          >
            爐次調動
          </button>
          <button
            v-if="meltSchedule.length != 0"
            type="button"
            class="btn edit-btn"
            :class="{ active: transferStatus == 2 }"
            @click="transferStatus = 2"
          >
            訂單異動
          </button>
        </template>
      </div>

      <div class="col-12">
        <template v-if="meltSchedule.length != 0">
          <div class="text-start">
            <button
              v-for="(item, index) in version"
              @click="changeVersion(index)"
              class="btn version-btn me-2 mb-1"
              :class="{ active: userSelectVersion == index }"
              :disabled="mod"
            >
              {{ item }}
            </button>
          </div>
        </template>
        <div
          v-if="meltSchedule.length != 0"
          class="table-responsive my-2"
          ref="userTable"
        >
          <table class="table table-style sch-cal-table" :class="{ mod: mod }">
            <thead>
              <tr>
                <th>爐次Heats</th>
                <th colspan="3">1</th>
                <th colspan="3">2</th>
                <th colspan="3">3</th>
                <th colspan="3">4</th>
                <th colspan="3">5</th>
                <th colspan="3">6</th>
                <th colspan="3">7</th>
                <th colspan="3">8</th>
                <th colspan="3">9</th>
                <th colspan="3">10</th>
                <th colspan="3">11</th>
                <th colspan="3">12</th>
                <th colspan="2">鍛機鍛模順序</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(item, index) in meltSchedule">
                <tr>
                  <template v-for="(itemData, itemIndex) in item">
                    <!-- 鍛機鍛模順序 開始 -->
                    <template
                      v-if="
                        [1].indexOf(index) != -1 &&
                        [37, 38].indexOf(itemIndex) != -1
                      "
                    >
                      <td rowspan="2">{{ itemData }}</td>
                    </template>
                    <template
                      v-else-if="
                        [3, 6, 9, 12, 15, 18].indexOf(index) != -1 &&
                        [37, 38].indexOf(itemIndex) != -1
                      "
                    >
                      <td rowspan="3">{{ itemData }}</td>
                    </template>
                    <template
                      v-else-if="
                        [2, 4, 5, 7, 8, 10, 11, 13, 14, 16, 17, 19, 20].indexOf(
                          index
                        ) != -1 && [37, 38].indexOf(itemIndex) != -1
                      "
                    >
                    </template>
                    <!-- 鍛機鍛模順序 結束 -->

                    <template v-else>
                      <td
                        @click="mod ? editItem(index, itemIndex) : ''"
                        :class="{
                          steel_def:
                            Math.ceil(itemIndex / 3) > 0 &&
                            Math.ceil(itemIndex / 3) < 13 &&
                            week_days[Math.floor(index / 3)] &&
                            Math.ceil(itemIndex / 3) >
                              week_days[Math.floor(index / 3)].steel_count,
                        }"
                      >
                        {{ itemData }}
                      </td>
                    </template>
                  </template>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
        <template v-if="mod">
          <!-- 爐次調動 -->
          <!-- 訂單異動 -->
          <div class="mt-3">
            <h5>暫存區</h5>
            <div
              class="row row-cols-1 row-cols-md-3 g-4"
              style="min-height: 200px"
            >
              <div v-for="(item, index) in storageFurnaces" class="col">
                <div
                  class="card text-dark border-dark"
                  :class="{
                    'bg-cus-green': furnaceSelect == index,
                    'text-white': furnaceSelect == index,
                  }"
                  @click="transferStatus == 1 ? selectFurnaceItem(index) : ''"
                >
                  <div class="card-body">
                    <div
                      class="card-text text-start row row-cols-3 overflow-hidden"
                    >
                      <div
                        class="col mx-0 px-0"
                        style="overflow: initial; text-wrap: nowrap"
                      >
                        {{ item.furnace_lot }}
                      </div>
                      <div
                        v-for="num in 5"
                        class="col mx-0 px-0"
                        style="overflow: initial; text-wrap: nowrap"
                      >
                        {{
                          item.material[num - 1] != undefined
                            ? item.material[num - 1]
                            : ""
                        }}
                      </div>
                      <div
                        class="col mx-0 px-0"
                        style="overflow: initial; text-wrap: nowrap"
                      >
                        {{ item.sug_m_group }}
                      </div>
                      <div
                        class="col mx-0 px-0"
                        style="overflow: initial; text-wrap: nowrap"
                      >
                        {{
                          item.material[5] != undefined ? item.material[5] : ""
                        }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="my-3 text-end">
            <button
              type="button"
              class="btn p-0 me-2"
              style="
                color: #fff;
                background-color: #4b8c80;
                width: 6rem;
                height: 2rem;
                font-size: 1.125rem;
              "
              @click="cancelMeltSchedule"
            >
              取消編輯
            </button>
            <button
              type="button"
              class="btn p-0 me-2"
              style="
                color: #fff;
                background-color: #4b8c80;
                width: 6rem;
                height: 2rem;
                font-size: 1.125rem;
              "
              @click="checkEditMeltSchedule"
            >
              送出編輯
            </button>
          </div>
        </template>
      </div>
    </div>
    <div class="col-1"></div>
    <commonModal :modalShow="modalShow" :size="'xl'">
      <template v-slot:modalheader>
        <button type="button" class="close" @click="closeModalShow">×</button>
      </template>
      <template v-slot:default>
        <div class="text-start mb-3">
          爐號: {{ modalContext.furnace_lot }} 鋼種:
          <template v-if="!addModalStatus">
            {{ modalContext.sug_m_group }}
          </template>
          <template v-else>
            <input
              type="text"
              name="sug_m_group"
              v-model="addModalContext.sug_m_group"
            />
          </template>
          備註:
          <template v-if="!addModalStatus && !editModalNote">
            {{
              modalContext.furnace_lot_note == ""
                ? "-"
                : modalContext.furnace_lot_note
            }}
          </template>
          <template v-else-if="editModalNote">
            <input
              type="text"
              name="furnace_lot_note"
              v-model="modalContext.furnace_lot_note"
            />
          </template>
          <template v-else>
            <input
              type="text"
              name="furnace_lot_note"
              v-model="addModalContext.furnace_lot_note"
            />
          </template>
        </div>
        <commonTable
          class="mb-3"
          :fields="modalContextListTableFields"
          :items="
            addModalStatus && !editModalNote
              ? addModalContext.list
              : modalContext.list
          "
        >
          <template #cell(order_sn)="data">
            <template v-if="addModalStatus && !editModalNote">
              <input
                type="text"
                name="order_sn"
                class="form-control"
                :disabled="editModalNote"
                v-model="addModalContext.list[data.index].order_sn"
              />
            </template>
            <template v-else>{{ data.value }}</template>
          </template>
          <template #cell(material_pcs)="data">
            <template v-if="addModalStatus && !editModalNote">
              <input
                type="number"
                min="1"
                name="material_pcs"
                class="form-control"
                v-model="addModalContext.list[data.index].material_pcs"
              />
            </template>
            <template v-else>{{ data.value }}</template>
          </template>
          <template #cell(material_type)="data">
            <template v-if="addModalStatus && !editModalNote">
              <input
                class="form-control"
                list="datalistOptions"
                name="commonTextInputList"
                v-model="addModalContext.list[data.index].material_type"
              />
              <datalist id="datalistOptions">
                <option
                  v-for="option in materialTypeOption"
                  :data-value="option.text"
                >
                  {{ option.text }}
                </option>
              </datalist>
            </template>
            <template v-else>{{ data.value }}</template>
          </template>
          <template #cell(weight)="data">
            {{ data.value }}
          </template>
          <template #cell(circle_note)="data">
            <template v-if="addModalStatus && !editModalNote">
              <input
                type="checkbox"
                name="noteCheckbox"
                v-model="addModalContext.list[data.index].circle_note"
              />
            </template>
            <template v-else-if="editModalNote">
              <input
                type="checkbox"
                name="noteCheckbox"
                v-model="modalContext.list[data.index].circle_note"
              />
            </template>
            <template v-else>{{ data.value ? "✔" : "" }}</template>
          </template>
          <template #cell(triangle_note)="data">
            <template v-if="addModalStatus && !editModalNote">
              <input
                type="checkbox"
                name="noteCheckbox"
                v-model="addModalContext.list[data.index].triangle_note"
              />
            </template>
            <template v-else-if="editModalNote">
              <input
                type="checkbox"
                name="noteCheckbox"
                v-model="modalContext.list[data.index].triangle_note"
              />
            </template>
            <template v-else>{{ data.value ? "✔" : "" }}</template>
          </template>
          <template #cell(star_note)="data">
            <template v-if="addModalStatus && !editModalNote">
              <input
                type="checkbox"
                name="noteCheckbox"
                v-model="addModalContext.list[data.index].star_note"
              />
            </template>
            <template v-else-if="editModalNote">
              <input
                type="checkbox"
                name="noteCheckbox"
                v-model="modalContext.list[data.index].star_note"
              />
            </template>
            <template v-else>{{ data.value ? "✔" : "" }}</template>
          </template>
        </commonTable>
      </template>

      <template v-slot:modalfooter>
        <template v-if="modalContext.furnace_lot != '-'">
          <button
            type="button"
            class="btn p-0 me-2"
            style="
              color: #fff;
              background-color: #4b8c80;
              width: 6rem;
              height: 2rem;
              font-size: 1.125rem;
            "
            @click="editModalNote = !editModalNote"
          >
            {{ editModalNote ? "完成備註" : "編輯備註" }}
          </button>
          <button
            type="button"
            class="btn p-0 me-2"
            style="
              color: #fff;
              background-color: #4b8c80;
              width: 6rem;
              height: 2rem;
              font-size: 1.125rem;
            "
            @click="clearFurnace"
          >
            清除此爐
          </button>
        </template>
        <template v-else>
          <button
            v-if="!addModalStatus"
            type="button"
            class="btn p-0 me-2"
            style="
              color: #fff;
              background-color: #4b8c80;
              width: 6rem;
              height: 2rem;
              font-size: 1.125rem;
            "
            @click="addFurnace"
          >
            新增資料
          </button>
          <button
            v-else
            type="button"
            class="btn p-0 me-2"
            style="
              color: #fff;
              background-color: #4b8c80;
              width: 6rem;
              height: 2rem;
              font-size: 1.125rem;
            "
            @click="checkAddFurnace"
          >
            確認新增
          </button>
        </template>
      </template>
    </commonModal>
    <commonModal :modalShow="meltSchedulePlanningModalShow" :size="'lg'">
      <template v-slot:modalheader>
        <div class="w-100 text-center text-white">請輸入起始爐號</div>
      </template>

      <template v-slot:default>
        <div class="text-center mb-3">
          起始爐號:
          <input
            type="text"
            name="start_furnace_lot"
            v-model="meltSchedulePlanningFurnaceLot"
            placeholder="SR0001"
          />
        </div>
        <div>
          <button
            type="button"
            class="btn p-0 me-2"
            style="
              color: #fff;
              background-color: #4b8c80;
              width: 6rem;
              height: 2rem;
              font-size: 1.125rem;
            "
            @click="cancelMeltSchedulePlanning"
          >
            取消
          </button>
          <button
            type="button"
            class="btn p-0 me-2"
            style="
              color: #fff;
              background-color: #4b8c80;
              width: 6rem;
              height: 2rem;
              font-size: 1.125rem;
            "
            @click="meltSchedulePlanning"
          >
            確定
          </button>
        </div>
      </template>
    </commonModal>
  </div>
</template>

<script>
import commonQueryInput from "@/components/commonQueryInput.vue";
import exportCsv from "@/components/exportCsv.vue";
import commonTable from "@/components/commonTable.vue";
import commonModal from "@/components/commonModal.vue";
import { computed, inject, ref, watch } from "vue";
import { useStore } from "vuex";
export default {
  components: {
    commonQueryInput,
    exportCsv,
    commonTable,
    commonModal,
  },
  setup() {
    const store = useStore();

    //getters
    const loginData = computed(() => store.getters["getLogin/get_loginData"]);
    const sideNavPath = computed(
      () => store.getters["sideBarTree/get_sideNavPath"]
    );
    const axiosResult = computed(
      () => store.getters["commonAxios/get_axiosResult"]
    );
    const exportTitleData = computed(
      () => store.getters["scheduleCalculation/get_exportTitleData"]
    );
    const exportInstructionsData = computed(
      () => store.getters["scheduleCalculation/get_exportInstructionsData"]
    );
    const exportMerge = computed(
      () => store.getters["scheduleCalculation/get_exportMerge"]
    );
    const exportExcelStyle = computed(
      () => store.getters["scheduleCalculation/get_exportExcelStyle"]
    );

    //dispatch
    const methods = {
      axiosAction: async (payload) => {
        await store.dispatch("commonAxios/axiosAction", payload);
      },
      triggerLoadingBar: () => {
        store.dispatch("commonLoadingBar/triggerLoadingBar");
      },
      setTimeoutAlert: (alertText) => {
        store.dispatch("commonAlert/setTimeoutAlert", [alertText]);
      },
      set_dateRange: (alertText) => {
        store.dispatch("scheduleCalculation/set_dateRange", [alertText]);
      },
      set_formWeek: (alertText) => {
        store.dispatch("scheduleCalculation/set_formWeek", [alertText]);
      },
      set_revNo: (alertText) => {
        store.dispatch("scheduleCalculation/set_revNo", [alertText]);
      },
    };

    const currentYear = new Date().getFullYear();
    const yearOptins = ref([]);
    const currentWeek = ref(1);
    const weekOptions = ref([]);

    const meltSchedule = ref([]);

    const week_days = ref([]);
    const version = ref([]);
    const melting_plan = ref([]);
    const showMeltingPlan = ref([]);
    const forge_data = ref({});
    const exportData = ref([]);
    const date_range = ref("");

    const path = inject("path");
    const multiInputVal = ref();
    const multiInputItems = ref([
      {
        key: "year",
        label: "年度",
        checkEmpty: true,
        type: "select", // date/dateBetween/text/select/time/month
        checkEmpty: true,
        disableText: "-- 選擇年度 --",
        options: yearOptins,
        disableValue: currentYear,
      },
      {
        key: "week",
        label: "周次",
        type: "select",
        checkEmpty: true,
        disableText: "-- 選擇周次 --",
        options: weekOptions,
        disableValue: currentWeek,
      },
    ]);
    const query = ref(false);
    const userSelect = ref({ year: null, week: null });
    const userSelectVersion = ref(-1);

    const userTable = ref(null);
    const changeVersion = (index) => {
      userSelectVersion.value = index;

      userTable.value.scrollTo({
        left: 0,
        behavior: "smooth",
      });
    };

    const plan = ref(false);
    const mod = ref(false);
    const orgShowMeltingPlan = ref([]);
    const transferStatus = ref(1);
    const editMeltSchedule = () => {
      mod.value = true;
      userSelectVersion.value = 0;
      orgShowMeltingPlan.value = JSON.parse(
        JSON.stringify(melting_plan.value[version.value[0]])
      );
      storageFurnaces.value = [];
      modalContext.value = [];
      transferStatus.value = 1;
    };
    const storageFurnaces = ref([]);
    const furnaceSelect = ref(-1);
    const modalShow = ref(false);
    const meltSchedulePlanningModalShow = ref(false);
    const meltSchedulePlanningFurnaceLot = ref("");
    const modalContext = ref([]);
    const editModalNote = ref(false);
    const orgModalContext = ref([]);
    const addModalStatus = ref(false);
    const addModalContext = ref({});
    const addModalFurnacesCount = ref(0);
    const cancelMeltSchedule = () => {
      mod.value = false;
      showMeltingPlan.value = JSON.parse(
        JSON.stringify(orgShowMeltingPlan.value)
      );
      orgShowMeltingPlan.value = [];
      meltSchedule.value = transMeltingPlan(showMeltingPlan.value);
    };
    const modalContextListTableFields = ref([
      {
        key: "order_sn",
        label: "訂單流水號",
        thStyle: {
          "min-width": "130px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "material_pcs",
        label: "支數",
        thStyle: {
          "min-width": "130px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "material_type",
        label: "鑄型",
        thStyle: {
          "min-width": "130px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "weight",
        label: "重量",
        thStyle: {
          "min-width": "130px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "circle_note",
        label: "●",
        thStyle: {
          "min-width": "120px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "triangle_note",
        label: "△",
        thStyle: {
          "min-width": "120px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "star_note",
        label: "★",
        thStyle: {
          "min-width": "120px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
    ]);
    const checkEditMeltSchedule = () => {
      for (let i = 0; i < showMeltingPlan.value.length; i++) {
        const arr = showMeltingPlan.value[i];
        if (i % 12 >= week_days.value[Math.floor(i / 12)].steel_count) {
          if (arr.furnace_lot != "") {
            methods.setTimeoutAlert("超過爐數上限，請確認！");
            return;
          }
        }
      }

      let updateData = [];
      for (let i = 0; i < showMeltingPlan.value.length; i++) {
        const arr1 = showMeltingPlan.value[i];
        const arr2 = orgShowMeltingPlan.value[i];
        if (arr1.furnace_lot != arr2.furnace_lot) {
          updateData.push(showMeltingPlan.value[i]);
          continue;
        }
        if (arr1.furnace_lot_note != arr2.furnace_lot_note) {
          updateData.push(showMeltingPlan.value[i]);
          continue;
        }
        const sortedStr1 = arr1.material.sort().join();
        const sortedStr2 = arr2.material.sort().join();
        if (sortedStr1 != sortedStr2) {
          updateData.push(showMeltingPlan.value[i]);
          continue;
        }
      }

      if (updateData.length == 0) {
        methods.setTimeoutAlert("無修改項目");
        return;
      }

      methods.triggerLoadingBar();
      let params = {};
      params["webPage"] =
        sideNavPath.value.length != 0
          ? sideNavPath.value[sideNavPath.value.length - 1]
          : null;
      params["user"] = loginData.value.account;
      params["vuePage"] = path.value;
      console.log(path.value);
      params["methods"] = "POST";
      params["whichFunction"] = "UpdateScheduleCalculation";
      params["year"] = userSelect.value.year;
      params["week"] = userSelect.value.week;
      params["meltingPlan"] = showMeltingPlan.value;

      methods.axiosAction(params).then(() => {
        console.log(axiosResult.value);
        let result = axiosResult.value;
        let response = result.Response;
        if (response == "ok") {
          mod.value = false;
          orgShowMeltingPlan.value = [];
          methods.triggerLoadingBar();
          queryScheduleCalculation();
        } else {
          methods.triggerLoadingBar();
          methods.setTimeoutAlert(response);
        }
      });
    };
    const cancelMeltSchedulePlanning = () => {
      meltSchedulePlanningModalShow.value = false;
      meltSchedulePlanningFurnaceLot.value = "";
    };

    const meltSchedulePlanning = () => {
      if (meltSchedulePlanningFurnaceLot.value.length < 6) {
        methods.setTimeoutAlert("爐號須為6個字的長度");
        return;
      }

      // 檢查開頭兩個字母是否為大寫英文字母
      var firstTwoChars = meltSchedulePlanningFurnaceLot.value.substring(0, 2);
      if (!/^[A-Z]{2}$/.test(firstTwoChars)) {
        methods.setTimeoutAlert("開頭兩個字母需為大寫英文字母");
        return;
      }

      // 檢查後面四個字元是否為數字
      var lastFourChars = meltSchedulePlanningFurnaceLot.value.substring(2);
      if (!/^\d{4}$/.test(lastFourChars)) {
        methods.setTimeoutAlert("後面四個字需為數字");
        return;
      }
      meltSchedulePlanningModalShow.value = false;
      methods.triggerLoadingBar();
      let params = {};
      params["webPage"] =
        sideNavPath.value.length != 0
          ? sideNavPath.value[sideNavPath.value.length - 1]
          : null;
      params["user"] = loginData.value.account;
      params["vuePage"] = path.value;
      console.log(path.value);
      params["methods"] = "POST";
      params["whichFunction"] = "MeltSchedulePlanning";
      params["year"] = userSelect.value.year;
      params["week"] = userSelect.value.week;
      params["furnace"] = meltSchedulePlanningFurnaceLot.value;

      methods.axiosAction(params).then(() => {
        console.log(axiosResult.value);
        let result = axiosResult.value;
        let response = result.Response;
        if (response == "ok") {
          queryScheduleCalculation();
        } else {
          week_days.value = [];
          version.value = [];
          melting_plan.value = {};
          showMeltingPlan.value = [];
          forge_data.value = [];
          exportData.value = [];
          userSelectVersion.value = -1;
          methods.setTimeoutAlert(response);
        }
        methods.triggerLoadingBar();
      });
    };

    //匯出資料的檔案名稱
    const exportFileName = () => {
      let exportFileName = "";
      exportFileName = `排程試算_WEEK${userSelect.value.year}${String(
        userSelect.value.week
      ).padStart(2, "0")}(${formatDateRange(date_range.value)})_${
        version.value[0]
      }`;
      return exportFileName;
    };

    const getYearOptins = () => {
      for (let year = currentYear; year >= currentYear - 5; year--) {
        yearOptins.value.push({
          value: year,
          text: year,
        });
      }
    };

    function formatDateRange(dateRange) {
      // 將日期範圍字符串拆分為起始日期和結束日期
      const dates = dateRange.split("~");
      // 將起始日期和結束日期分別進行格式化
      const formattedStartDate = formatDate(dates[0]);
      const formattedEndDate = formatDate(dates[1]);
      // 將格式化後的日期組合成日期範圍字符串
      const formattedDateRange = formattedStartDate + "~" + formattedEndDate;
      return formattedDateRange;
    }

    function formatDate(inputDate) {
      // 將日期字符串拆分為年、月和日部分
      const parts = inputDate.split("/");
      // 建立新的日期字串，並將年、月、日部分連接在一起
      const formattedDate =
        parts[2] + parts[0].padStart(2, "0") + parts[1].padStart(2, "0");
      return formattedDate;
    }

    const getCurrentWeek = () => {
      const currentDate = new Date();
      const dayOfWeek = currentDate.getDay();
      if (dayOfWeek >= 0 && dayOfWeek <= 4) {
        currentWeek.value = getWeekNumber(currentDate);
      } else {
        currentWeek.value = getWeekNumber(currentDate) + 1;
      }
    };

    const getWeekNumber = (date) => {
      const target = new Date(date.valueOf());
      const dayNr = (date.getDay() + 6) % 7;
      target.setDate(target.getDate() - dayNr + 3);
      const firstThursday = target.valueOf();
      target.setMonth(0, 1);
      if (target.getDay() !== 4) {
        target.setMonth(0, 1 + ((4 - target.getDay() + 7) % 7));
      }
      return 1 + Math.ceil((firstThursday - target) / 604800000);
    };

    function getISOWeeksInYear(year) {
      const d = new Date(year, 11, 31);
      const day = d.getDay();
      return day === 4 || (day === 3 && isLeapYear(year)) ? 53 : 52;
    }

    function isLeapYear(year) {
      return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    const getWeekOptions = () => {
      for (let week = 1; week <= getISOWeeksInYear(currentYear); week++) {
        weekOptions.value.push({
          value: week,
          text: week,
        });
      }
    };

    const queryScheduleCalculation = () => {
      methods.triggerLoadingBar();
      let params = {};
      params["webPage"] =
        sideNavPath.value.length != 0
          ? sideNavPath.value[sideNavPath.value.length - 1]
          : null;
      params["user"] = loginData.value.account;
      params["vuePage"] = path.value;
      console.log(path.value);
      params["methods"] = "POST";
      params["whichFunction"] = "QueryScheduleCalculation";
      params["year"] = userSelect.value.year;
      params["week"] = userSelect.value.week;

      methods.axiosAction(params).then(() => {
        console.log(axiosResult.value);
        let result = axiosResult.value;
        let response = result.Response;
        if (response == "ok") {
          let queryTableData = result.QueryTableData;
          query.value = true;
          week_days.value = queryTableData.week_days;
          let versionData = Object.keys(queryTableData.melting_plan);
          versionData.sort((a, b) => {
            return parseInt(b, 10) - parseInt(a, 10);
          });
          version.value = versionData;
          if (version.value.length != 0) {
            melting_plan.value = queryTableData.melting_plan;
            userSelectVersion.value = 0;
            forge_data.value = queryTableData.forge_data;
            date_range.value = queryTableData.date_range;
          } else {
            week_days.value = [];
            melting_plan.value = {};
            userSelectVersion.value = -1;
            showMeltingPlan.value = [];
            forge_data.value = [];
          }
          methods.set_dateRange(queryTableData.date_range);
          methods.set_formWeek(queryTableData.formWeek);
          methods.set_revNo(queryTableData.rev_no);
          if (version.value.length != 0) {
            showMeltingPlan.value = JSON.parse(
              JSON.stringify(
                melting_plan.value[version.value[userSelectVersion.value]]
              )
            );
          }
          meltSchedule.value = transMeltingPlan(showMeltingPlan.value);
          changeExportData();
        } else {
          week_days.value = [];
          melting_plan.value = {};
          userSelectVersion.value = -1;
          showMeltingPlan.value = [];
          forge_data.value = [];
          exportData.value = [];
          methods.setTimeoutAlert(response);
        }
        methods.triggerLoadingBar();
      });
    };

    const changeExportData = () => {
      if (!melting_plan.value || typeof melting_plan.value !== "object") {
        melting_plan.value = {};
      }

      // 將原始物件的鍵以字串形式排序
      const sortedKeys = Object.keys(melting_plan.value).sort((a, b) => {
        return b.localeCompare(a); // 以字串比較來進行反向排序
      });

      let exportList = [];
      sortedKeys.forEach((key) => {
        exportList.push({
          sheetName: key,
          title: [],
          data: [
            ...exportTitleData.value,
            ...transMeltingPlan(melting_plan.value[key]),
            ...exportInstructionsData.value,
          ],
          merge: exportMerge,
          excelStyle: exportExcelStyle,
        });
      });
      exportData.value = exportList;
    };

    const editItem = (row, column) => {
      const meltScheduleIndex = findRecord(row, column);
      let overMaxSteel = false;
      if (
        Math.ceil(column / 3) > 0 &&
        Math.ceil(column / 3) < 13 &&
        week_days.value[Math.floor(row / 3)] &&
        Math.ceil(column / 3) > week_days.value[Math.floor(row / 3)].steel_count
      ) {
        overMaxSteel = true;
      }

      let furnace_lot =
        meltSchedule.value[meltScheduleIndex[0]][meltScheduleIndex[1]];

      if (transferStatus.value == 1) {
        //爐次調動
        if (furnace_lot != "") {
          const foundIndex = showMeltingPlan.value.findIndex(
            (item) => item.furnace_lot === furnace_lot
          );
          if (foundIndex !== -1) {
            // 取得 "爐號" 的資料
            const foundData = showMeltingPlan.value[foundIndex];

            // 將 "爐號" 的資料另存到新的陣列中
            storageFurnaces.value.push(foundData);

            // 將原始位置用空白資料取代
            showMeltingPlan.value[foundIndex] = {
              furnace_lot: "",
              sug_m_group: "",
              furnace_lot_note: "",
              material: [],
              list: [],
            };
          }
          meltSchedule.value = transMeltingPlan(showMeltingPlan.value);
        }

        if (furnaceSelect.value != -1) {
          if (overMaxSteel) {
            methods.setTimeoutAlert("不可放置超出爐數上限");
            return;
          }
          showMeltingPlan.value[
            Math.floor(meltScheduleIndex[0] / 3) * 12 +
              Math.floor(meltScheduleIndex[1] / 3)
          ] = storageFurnaces.value[furnaceSelect.value];

          storageFurnaces.value.splice(furnaceSelect.value, 1);
          furnaceSelect.value = -1;

          meltSchedule.value = transMeltingPlan(showMeltingPlan.value);
        }
      } else if (transferStatus.value == 2) {
        //訂單異動
        if (furnace_lot != "") {
          const foundIndex = showMeltingPlan.value.findIndex(
            (item) => item.furnace_lot === furnace_lot
          );
          if (foundIndex !== -1) {
            // 取得 "爐號" 的資料
            const foundData = showMeltingPlan.value[foundIndex];
            modalContext.value = JSON.parse(JSON.stringify(foundData));
          }
        } else {
          if (overMaxSteel) {
            methods.setTimeoutAlert("不可新增超出爐數上限");
            return;
          }
          modalContext.value = {
            furnace_lot: "-",
            sug_m_group: "-",
            furnace_lot_note: "-",
            material: [],
            list: [],
          };
        }

        editModalNote.value = false;
        addModalStatus.value = false;
        addModalContext.value = {
          pos: meltScheduleIndex,
        };
        modalShow.value = true;
      }
    };

    const findRecord = (row, column) => {
      // 計算每組的大小（行和列）
      const groupSize = 3; // 每組大小為 3

      // 計算給定行數在哪一組
      const rowGroup = Math.floor(row / groupSize);

      // 計算在組內的行索引
      const columnGroup = Math.floor((column - 1) / groupSize);

      // 返回對應的紀錄
      return [rowGroup * 3, columnGroup * 3 + 1];
    };

    const selectFurnaceItem = (index) => {
      furnaceSelect.value = furnaceSelect.value == index ? -1 : index;
    };

    const cancelMod = () => {
      mod.value = false;
      transferStatus.value = 1;
      storageFurnaces.value = [];
      furnaceSelect.value = -1;
    };

    const clearFurnace = () => {
      var result = confirm("確定要清除嗎？");

      // 如果使用者按下確認，執行清除動作
      if (result) {
        let furnace_lot = modalContext.value.furnace_lot;

        if (furnace_lot != "") {
          const foundIndex = showMeltingPlan.value.findIndex(
            (item) => item.furnace_lot === furnace_lot
          );
          if (foundIndex !== -1) {
            // 將原始位置用空白資料取代
            showMeltingPlan.value[foundIndex] = {
              furnace_lot: "",
              sug_m_group: "",
              material: [],
              list: [],
            };
          }
          meltSchedule.value = transMeltingPlan(showMeltingPlan.value);
        }
        modalShow.value = false;
      }
    };

    const addFurnace = () => {
      getIngotMoStock();
      addModalContext.value = {
        pos: addModalContext.value.pos,
        furnace_lot: "-",
        sug_m_group: "",
        furnace_lot_note: "",
        material: [],
        list: [
          {
            material_pcs: "",
            material_type: "",
            order_sn: "",
            weight: "",
            circle_note: false,
            triangle_note: false,
            star_note: false,
          },
        ],
      };
      addModalStatus.value = true;
    };

    const materialTypeData = ref([]);
    const materialTypeOption = ref([]);
    const getIngotMoStock = () => {
      let params = {};
      params["webPage"] =
        sideNavPath.value.length != 0
          ? sideNavPath.value[sideNavPath.value.length - 1]
          : null;
      params["user"] = loginData.value.account;
      params["vuePage"] = path.value;
      console.log(path.value);
      params["methods"] = "GET";
      params["whichFunction"] = "GetIngotMoStock";

      methods.axiosAction(params).then(() => {
        console.log(axiosResult.value);
        let result = axiosResult.value;
        let response = result.Response;
        if (response == "ok") {
          let queryTableData = result.QueryTableData;
          materialTypeData.value = queryTableData.material_type_data;
          materialTypeOption.value = queryTableData.material_type_option;
        } else {
          materialTypeData.value = [];
          materialTypeOption.value = [];
          console.log(response);
        }
      });
    };

    const checkAddFurnace = () => {
      // 首先確認 sug_m_group 不為空
      if (addModalContext.value.sug_m_group == "") {
        methods.setTimeoutAlert("鋼種不可為空");
        return;
      }
      const materialMap = {};
      // 整理list的material_type及material_pcs
      let newItem = [];
      let material_type_data = {};
      addModalContext.value.list.forEach((item, index) => {
        const {
          order_sn,
          material_type,
          material_pcs,
          weight,
          circle_note,
          triangle_note,
          star_note,
        } = item;
        if (
          order_sn != "" &&
          material_type != "" &&
          parseFloat(material_pcs) > 0
        ) {
          materialMap[material_type] ??= { normal: 0 };
          material_type_data[material_type] ??= 0;

          const trans_note = {
            circle_note: "●",
            triangle_note: "△",
            star_note: "★",
          };

          let this_key = "";
          if (circle_note) this_key += trans_note.circle_note;
          if (triangle_note) this_key += trans_note.triangle_note;
          if (star_note) this_key += trans_note.star_note;

          if (!this_key) this_key = "normal";

          materialMap[material_type][this_key] ??= 0;
          materialMap[material_type][this_key] += parseFloat(material_pcs);

          material_type_data[material_type] += Number(weight);
          newItem.push(item);
        }
      });

      let material_type_array = Object.keys(material_type_data);
      if (material_type_array.length == 1) {
        if (
          Object.values(material_type_data)[0] / 1000 >
          materialTypeData.value[material_type_array[0]].steel_max
        ) {
          alert(
            `總重量不可超過${
              materialTypeData.value[material_type_array[0]].steel_max * 1000
            }公斤`
          );
          return;
        }
      } else if (material_type_array.length > 1) {
        let total_weight = 0;
        material_type_array.forEach((data) => {
          total_weight += Number(material_type_data[data]);
        });
        if (total_weight > 32000) {
          alert(`總重量不可超過32000公斤`);
          return;
        }
      }

      // 將整理後的material_type及material_pcs存入material
      addModalContext.value.material = [];
      Object.entries(materialMap).forEach(([type, typeData]) => {
        Object.entries(typeData).forEach(([note, pcs]) => {
          if (pcs !== 0) {
            let str = `${type}*${pcs}`;
            if (note !== "normal") str += ` ${note}`;
            addModalContext.value.material.push(str);
          }
        });
      });

      if (addModalContext.value.material.length > 6) {
        methods.setTimeoutAlert("鑄型不可大於6種，請重新選擇！");
        return;
      } else if (addModalContext.value.material.length == 0) {
        methods.setTimeoutAlert("請確認訂單流水號、支數、鑄型並完整填寫！");
        return;
      }

      addModalContext.value.list = newItem;

      if (addModalContext.value.furnace_lot_note != "") {
        if (addModalContext.value.material.length < 6) {
          addModalContext.value.material.push(
            addModalContext.value.furnace_lot_note
          );
        } else {
          addModalContext.value.material[
            addModalContext.value.material.length - 1
          ] += " " + addModalContext.value.furnace_lot_note;
        }
      }

      addModalFurnacesCount.value++;
      const paddedFurnaceLot = String(addModalFurnacesCount.value).padStart(
        3,
        "0"
      );
      addModalContext.value.furnace_lot = "ADD" + paddedFurnaceLot;

      showMeltingPlan.value[
        Math.floor(addModalContext.value.pos[0] / 3) * 12 +
          Math.floor(addModalContext.value.pos[1] / 3)
      ] = JSON.parse(JSON.stringify(addModalContext.value));
      meltSchedule.value = transMeltingPlan(showMeltingPlan.value);

      modalShow.value = false;
    };

    const closeModalShow = () => {
      if (orgModalContext.value.length != 0) {
        modalContext.value = JSON.parse(JSON.stringify(orgModalContext.value));
        orgModalContext.value = [];
      }
      modalShow.value = false;
    };

    //watch 按查詢鍵回傳所有輸入框的值
    watch(
      multiInputVal,
      (newValue) => {
        userSelect.value.year = newValue["year"];
        userSelect.value.week = newValue["week"];
        queryScheduleCalculation();
        cancelMod();
      },
      { deep: true }
    );
    //監聽使用者選擇的版本
    watch(userSelectVersion, (newValue) => {
      if (newValue == -1) {
        return;
      }
      showMeltingPlan.value = JSON.parse(
        JSON.stringify(melting_plan.value[version.value[newValue]])
      );
      meltSchedule.value = transMeltingPlan(showMeltingPlan.value);
    });
    //切換編輯模式時，重置使用者選擇
    watch(transferStatus, (newValue) => {
      furnaceSelect.value = -1;
    });
    //編輯備註時，顯示備註內容
    watch(editModalNote, (newValue) => {
      if (newValue == false && orgModalContext.value.length != 0) {
        if (modalContext.value.furnace_lot == "-") {
          return;
        }
        const materialMap = {};
        // 整理list的material_type及material_pcs
        modalContext.value.list.forEach((item) => {
          const {
            material_type,
            material_pcs,
            circle_note,
            triangle_note,
            star_note,
          } = item;

          if (material_type && material_pcs) {
            materialMap[material_type] ??= { normal: 0 };

            const trans_note = {
              circle_note: "●",
              triangle_note: "△",
              star_note: "★",
            };

            let this_key = "";
            if (circle_note) this_key += trans_note.circle_note;
            if (triangle_note) this_key += trans_note.triangle_note;
            if (star_note) this_key += trans_note.star_note;

            if (!this_key) this_key = "normal";

            materialMap[material_type][this_key] ??= 0;
            materialMap[material_type][this_key] += parseFloat(material_pcs);
          }
        });

        // 將整理後的material_type及material_pcs存入material
        modalContext.value.material = [];
        Object.entries(materialMap).forEach(([type, typeData]) => {
          Object.entries(typeData).forEach(([note, pcs]) => {
            if (pcs !== 0) {
              let str = `${type}*${pcs}`;
              if (note !== "normal") str += ` ${note}`;
              modalContext.value.material.push(str);
            }
          });
        });
        console.log(modalContext.value.material);
        if (modalContext.value.furnace_lot_note != "") {
          if (modalContext.value.material.length < 6) {
            modalContext.value.material.push(
              modalContext.value.furnace_lot_note
            );
          } else {
            modalContext.value.material[
              modalContext.value.material.length - 1
            ] += " " + modalContext.value.furnace_lot_note;
          }
        }
        const foundIndex = showMeltingPlan.value.findIndex(
          (item) => item.furnace_lot === modalContext.value.furnace_lot
        );
        if (foundIndex !== -1) {
          // 取代資料
          showMeltingPlan.value[foundIndex] = modalContext.value;
        }
        meltSchedule.value = transMeltingPlan(showMeltingPlan.value);
        orgModalContext.value = [];
      } else {
        orgModalContext.value = JSON.parse(JSON.stringify(modalContext.value));
      }
    });
    //監聽新增的爐號輸入框
    watch(
      addModalContext,
      (newValue) => {
        if (newValue.list == undefined) return;

        // 檢查 addModalContext.list 中的每個元素的key:material_pcs和material_type是否有值，如果有值則檢查materialTypeData.value裡是否存在materialTypeData.value[material_type].pcs_std_weg，如果存在則計算重量將值填入key:weight，不存在則為0，如果沒有值也為0
        newValue.list.forEach((item) => {
          if (
            item.material_pcs !== undefined &&
            item.material_pcs !== 0 &&
            item.material_type !== undefined &&
            item.material_type !== ""
          ) {
            if (materialTypeData.value[item.material_type] !== undefined) {
              // 計算重量並填入
              item.weight =
                item.material_pcs *
                materialTypeData.value[item.material_type].pcs_std_weg;
            } else {
              item.weight = 0;
            }
          } else {
            // 如果缺少 material_pcs 或 material_type
            item.weight = 0;
          }
        });

        // 檢查 addModalContext.list 中的每個元素(除了 key:note 和 key:weight) 是否都有值
        const allValuesExist = newValue.list.every((item) => {
          const keys = Object.keys(item);
          const otherValuesExist = keys
            .filter((key) => key !== "weight")
            .every((key) => {
              return item[key] !== "";
            });
          return otherValuesExist;
        });
        if (allValuesExist) {
          newValue.list.push({
            material_pcs: "",
            material_type: "",
            order_sn: "",
            weight: "",
            circle_note: false,
            triangle_note: false,
            star_note: false,
          });
        }
      },
      { deep: true }
    );

    getYearOptins();
    getCurrentWeek();
    getWeekOptions();

    const transMeltingPlan = (meltingPlanData) => {
      let schedule = [];
      week_days.value.forEach((day) => {
        schedule.push([day.day_of_week]);
        schedule.push([day.abbreviation]);
        schedule.push([day.date]);
      });
      // 處理熔煉計畫
      let currentDayIndex = 0;
      let currentPlanIndex = 0;

      while (currentDayIndex < week_days.value.length) {
        const plan = meltingPlanData[currentPlanIndex];

        if (!plan) break;

        const materials = plan.material;

        // 確保 schedule 有足夠的元素來容納這個日期的計畫
        for (let i = 0; i < 3; i++) {
          if (!schedule[currentDayIndex * 3 + i]) {
            schedule[currentDayIndex * 3 + i] = [];
          }
        }

        // 第一行
        // 加入 furnace_lot
        schedule[currentDayIndex * 3].push(plan.furnace_lot);
        // 加入 material
        for (let i = 0; i < 2; i++) {
          const dayMaterial = materials[i] || "";
          schedule[currentDayIndex * 3].push(dayMaterial);
        }

        // 第二行
        // 加入 material
        for (let i = 2; i < 5; i++) {
          const dayMaterial = materials[i] || "";
          schedule[currentDayIndex * 3 + 1].push(dayMaterial);
        }

        // 第三行
        // 加入 sug_m_group
        schedule[currentDayIndex * 3 + 2].push(plan.sug_m_group);
        // 加入 material
        schedule[currentDayIndex * 3 + 2].push(materials[5] || "");
        schedule[currentDayIndex * 3 + 2].push("");

        currentPlanIndex++;

        // 如果已達到一個日期的上限，則換下一個日期
        if (currentPlanIndex % 12 === 0) {
          currentDayIndex++;
        }
      }

      // 添加 forge_data 的值到 test 中
      Object.entries(forge_data.value).forEach(([key, value], index) => {
        schedule[0].push(key);
        value.forEach((data, valueIndex) => {
          if (valueIndex === 0) {
            schedule[1].push(data || "");
            // 將剩餘的行添加空值
            schedule[2].push("");
          } else {
            if (schedule[valueIndex * 3] !== undefined) {
              schedule[valueIndex * 3].push(data || "");
              // 將剩餘的行添加空值
              schedule[valueIndex * 3 + 1].push("");
              schedule[valueIndex * 3 + 2].push("");
            }
          }
        });
      });

      return schedule;
    };

    return {
      multiInputVal,
      multiInputItems,
      query,
      meltSchedulePlanning,
      exportFileName,
      meltSchedule,
      exportData,
      week_days,
      version,
      changeVersion,
      userSelectVersion,
      userTable,
      editMeltSchedule,
      plan,
      mod,
      editItem,
      storageFurnaces,
      furnaceSelect,
      selectFurnaceItem,
      transferStatus,
      modalShow,
      closeModalShow,
      meltSchedulePlanningModalShow,
      meltSchedulePlanningFurnaceLot,
      cancelMeltSchedulePlanning,
      modalContext,
      editModalNote,
      clearFurnace,
      addFurnace,
      addModalStatus,
      addModalContext,
      materialTypeData,
      materialTypeOption,
      checkAddFurnace,
      cancelMeltSchedule,
      modalContextListTableFields,
      checkEditMeltSchedule,
    };
  },
};
</script>

<style scoped>
.sch-cal-table tbody tr:not(:nth-child(3n)) td:nth-child(3n + 1) {
  border-bottom: 0px;
}

.sch-cal-table tbody tr:not(:nth-child(3n)) td:nth-child(3n + 2),
.sch-cal-table tbody tr:not(:nth-child(3n)) td:nth-child(3n + 3) {
  border-bottom: 0px;
  border-right: 0px;
}

.sch-cal-table tbody tr:nth-child(3n) td:nth-child(3n + 2),
.sch-cal-table tbody tr:nth-child(3n) td:nth-child(3n + 3) {
  border-right: 0px;
}

.sch-cal-table tbody tr:nth-child(2) td:nth-last-child(1),
.sch-cal-table tbody tr:nth-child(2) td:nth-last-child(2),
.sch-cal-table tbody tr:nth-child(3n + 1) td:nth-last-child(1),
.sch-cal-table tbody tr:nth-child(3n + 1) td:nth-last-child(2) {
  border-bottom: 1px solid #999;
  border-right: 1px solid #999;
  text-align: center;
}

.sch-cal-table {
  white-space: nowrap;
}
.sch-cal-table > thead {
  position: sticky;
  top: 0;
  z-index: 2;
}
.sch-cal-table > thead th {
  color: var(--main-font-color);
  background-color: var(--main-bg-color);
}
.sch-cal-table tbody {
  text-align: start;
}
.sch-cal-table tbody td:nth-child(1) {
  text-align: center;
}
.sch-cal-table td,
.sch-cal-table th {
  height: 2rem;
  min-width: 50px;
}

.sch-cal-table > thead > tr:nth-child(1) > th:nth-child(1),
.sch-cal-table > tbody > tr > td:nth-child(1) {
  position: sticky;
  left: 0;
}

.sch-cal-table.mod tr td {
  cursor: pointer;
}
.sch-cal-table.mod tr td:first-child,
.sch-cal-table.mod tr td:first-child:nth-last-child(1),
.sch-cal-table.mod tr td:first-child:nth-last-child(2) {
  cursor: default;
}

.version-btn {
  height: 2rem;
  line-height: 2rem;
  padding: 0px;
  width: 4.25rem;
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}
.version-btn.active {
  background-color: #4b8c80 !important;
  border-color: #4b8c80 !important;
}

.edit-btn {
  color: var(--main-font-color);
  background-color: #6c757d;
  border-color: #6c757d;
  min-width: 5rem;
  height: 1.375rem;
  padding: 0px 0.5rem;
  font-family: dfyuanstd-w7;
  font-size: 0.875rem;
  font-weight: normal;
}
.edit-btn.active {
  background-color: var(--main-bg-color);
  border-color: var(--main-bg-color);
}
.bg-cus-green {
  background-color: #60a79a;
}

.steel_def {
  background-color: #f2f2f2;
}
</style>
